import { CalendarEvent } from '../calendarEvent';

const getEndTime = (calendarEvent: CalendarEvent) => {
  return (
    calendarEvent.endDate ??
    addMinutesToDate(
      calendarEvent.startDate,
      calendarEvent.durationInMinutes ?? 0
    )
  );
};

const MINUTE_IN_MS = 60 * 1000;
const addMinutesToDate = (date: Date, minutes: number) => {
  return new Date(date.getTime() + minutes * MINUTE_IN_MS);
};

const formatDateForCalendarUrl = (date: Date) => {
  return date.toISOString().replace(/-|:|\.\d+/g, '');
};

const helpers = {
  formatTime(date: Date) {
    return date.toISOString().replace(/-|:|\.\d+/g, '');
  },
  getEventDurationForYahoo(calendarEvent: CalendarEvent) {
    const eventDuration = calendarEvent.endDate
      ? (calendarEvent.endDate.getTime() - calendarEvent.startDate.getTime()) /
        MINUTE_IN_MS
      : calendarEvent.durationInMinutes || 0;

    // Yahoo dates are crazy, we need to convert the duration from minutes to hh:mm
    const yahooHourDuration =
      eventDuration < 600
        ? `0${Math.floor(eventDuration / 60)}`
        : `${Math.floor(eventDuration / 60)}`;

    const yahooMinuteDuration =
      eventDuration % 60 < 10
        ? `0${eventDuration % 60}`
        : `${eventDuration % 60}`;

    const yahooEventDuration = yahooHourDuration + yahooMinuteDuration;

    return yahooEventDuration;
  },
};

export const defaultEmptyGenerateFunction = (calendarEvent: CalendarEvent) => {
  calendarEvent;
};

export const generateGoogleCalendarEvent = (calendarEvent: CalendarEvent) => {
  const startDate = formatDateForCalendarUrl(calendarEvent.startDate);
  const endDate = formatDateForCalendarUrl(getEndTime(calendarEvent));

  const encodedUrl = encodeURI(
    [
      'https://www.google.com/calendar/render',
      '?action=TEMPLATE',
      `&text=${calendarEvent.title || ''}`,
      `&dates=${startDate || ''}`,
      `/${endDate || ''}`,
      // TODO: append video appointment link to description
      `&details=${
        `${calendarEvent.description}\n` + `https://cemkiray.com` || ''
      }`,
      `&location=${calendarEvent.address || ''}`,
      '&sprop=&sprop=name:',
    ].join('')
  );

  window.open(encodedUrl, '_blank');
};

export const generateYahooCalendarEvent = (calendarEvent: CalendarEvent) => {
  const st = helpers.formatTime(calendarEvent.startDate);
  const duration = helpers.getEventDurationForYahoo(calendarEvent);

  const encodedUrl = encodeURI(
    [
      'http://calendar.yahoo.com/?v=60&view=d&type=20',
      `&title=${calendarEvent.title || ''}`,
      `&st=${st || ''}`,
      `&dur=${duration || ''}`,
      `&desc=${calendarEvent.description || ''}`,
      `&in_loc=${calendarEvent.address || ''}`,
    ].join('')
  );

  window.open(encodedUrl, '_blank');
};

// Generates ICS for Apple and Outlook calendars
export const generateIcsCalendarFile = (calendarEvent: CalendarEvent) => {
  const startDate = formatDateForCalendarUrl(calendarEvent.startDate);
  const endDate = formatDateForCalendarUrl(getEndTime(calendarEvent));

  const encodedUrl = encodeURI(
    `data:text/calendar;charset=utf8,${[
      'BEGIN:VCALENDAR',
      'VERSION:2.0',
      'BEGIN:VEVENT',
      `DTSTART:${startDate || ''}`,
      `DTEND:${endDate || ''}`,
      `SUMMARY:${calendarEvent.title || ''}`,
      `DESCRIPTION:${
        calendarEvent.description
          ? calendarEvent.description.replace(/\n/g, '\\n')
          : ''
      }`,
      `LOCATION:${calendarEvent.address || ''}`,
      'END:VEVENT',
      'END:VCALENDAR',
    ].join('\n')}`
  );

  window.open(encodedUrl);
};
